import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["clauseList", "addButton", "template", "emptyState"]
  static values = { newIndex: Number }

  connect() {
    this.newIndexValue = 0
    this.updateEmptyState()
    this.initializeCKEditors()
  }

  initializeCKEditors() {
    document.querySelectorAll(".ckeditor").forEach(textarea => {
      if (!textarea.dataset.ckeditorInitialized) {
        ClassicEditor
          .create(textarea)
          .then(editor => textarea.dataset.ckeditorInitialized = true)
          .catch(console.error)
      }
    })
  }

  addClause(event) {
    event.preventDefault()
    const newIndex = this.newIndexValue++
    const html = this.templateTarget.innerHTML
      .replace(/NEW_RECORD/g, Date.now())
      .replace(/new_clause/g, `agreement_blueprint[agreement_clauses_attributes][${newIndex}]`)

    const wrapper = document.createElement("div")
    wrapper.innerHTML = html
    const newCard = wrapper.firstElementChild
    this.clauseListTarget.appendChild(newCard)

    this.updateEmptyState()
    this.initializeCKEditors()
    newCard.scrollIntoView({ behavior: "smooth", block: "center" })
    newCard.querySelector('input[name*="title"]')?.focus()
  }

  removeClause(event) {
    event.preventDefault()
    const card = event.target.closest(".clause-card")
    if (!card) return

    const destroyInput = card.querySelector('input[name*="_destroy"]')
    const clauseId = card.dataset.id

    if (clauseId) {
      destroyInput.value = "1"
      card.style.display = "none"
    } else {
      card.remove()
    }

    this.updateEmptyState()
  }

  updateEmptyState() {
    if (!this.hasEmptyStateTarget || !this.hasClauseListTarget) return
    const empty = this.clauseListTarget.children.length === 0 ||
                  Array.from(this.clauseListTarget.children).every(c => c.style.display === "none")
    this.emptyStateTarget.style.display = empty ? "block" : "none"
  }
}
